import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout } from 'antd';
import { Modal as ModalMobile } from 'antd-mobile';
import * as SignalR from '@aspnet/signalr';
import HomeHeaderMenu from '../../modules/ThemeThree/HomeHeaderMenu';
import HomeHeader from '../HomeHeader/HomeHeader';
import HomeEventAndFacility from '../HomeEventAndFacility/HomeEventAndFacility';
import HomeFnbOffer from '../../modules/ThemeOne/HomeFnbOffer';
import HomeShoppingOffer from '../../modules/ThemeOne/HomeShoppingOffer';
import { Markup } from 'interweave';
import IdleTimer from 'react-idle-timer';
import feacbookIcon from '../../assets/image/feacbook.png';
import instagramIcon from '../../assets/image/instagram.png';
import LinkedIn from '../../assets/image/LinkedIn.png';

const { Content } = Layout;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;
const confirmAlert = ModalMobile.alert;

@inject(
    'VersionStore',
    'templateStore',
    'CmsLanguageStore',
    'popupStore',
    'webSettingStore',
    'loginStore',
    'CmsFacilityHotelStore',
    'CmsEventHotelStore',
    'homeSpecialOfferStore',
    'homeRetailOfferStore',
)
@observer
class HomeThemeOne extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: ['1', '2', '3']
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.CmsFacilityHotelStore.getAllByLanguage();
        this.props.CmsEventHotelStore.getAllByLanguage();
        this.props.homeSpecialOfferStore.initAvailable();
        this.props.homeRetailOfferStore.initAvailable();
        this.props.CmsLanguageStore.getActives().then(() => {
            this.props.templateStore.getActive().then(() => {
                this.props.webSettingStore.getData().then(() => {
                    const { activeTemplate } = this.props.templateStore;
                    const { data: webSettting } = this.props.webSettingStore;

                    if (webSettting) {
                        this.props.popupStore.getByModuleName('HOME').then(resp => {
                            if (resp) {
                                const homePopupShown = window.localStorage.getItem('homePopupShown');
                                const homePopupTitle = window.localStorage.getItem('homePopupTitle');
                                const homePopupDescription = window.localStorage.getItem('homePopupDescription');

                                if (!homePopupShown) {
                                    this.showHomePopup(resp, activeTemplate);
                                } else {
                                    if (homePopupTitle !== resp.title || homePopupDescription !== resp.description) {
                                        this.showHomePopup(resp, activeTemplate);
                                    }
                                }
                            }

                        });
                    }
                });
            });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    componentWillUnmount() {
    }

    showHomePopup = (resp, activeTemplate) => {
        if (resp) {
            if (resp.title) {
                confirmAlert(
                    <div style={{
                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                        color: activeTemplate.templateSetting.label.color,
                        fontSize: activeTemplate.templateSetting.label.fontSize,
                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                    }}>
                        <span>{resp.title}</span>
                    </div>,
                    <div style={{
                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                        color: activeTemplate.templateSetting.text.color,
                        fontSize: activeTemplate.templateSetting.text.fontSize,
                        lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
                    }}>
                        <Markup content={resp.description} />
                    </div>,
                    [
                        {
                            text: <span style={{
                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                color: activeTemplate.templateSetting.label.color,
                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                            }}>OK</span>,
                            onPress: () => {
                                window.localStorage.setItem('homePopupShown', true);
                                window.localStorage.setItem('homePopupTitle', resp.title);
                                window.localStorage.setItem('homePopupDescription', resp.description);
                            }
                        }
                    ]);
            }
        }
    }

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    render() {
        const history = this.props.history;
        const { activeTemplate } = this.props.templateStore;
        const { data: webSettting } = this.props.webSettingStore;

        return (
            <Layout>
                <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                <Content
                style={{
    backgroundImage: webSettting?.homeImageUrl ? `url(${webSettting.homeImageUrl})` : 'none',
    backgroundColor: webSettting?.homeImageUrl ? 'transparent' : 'black',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
}}
            >
                    <HomeHeaderMenu history={history} />
                </Content>

                <HomeEventAndFacility history={history} />

                <HomeHeader history={history} className={'stm-width-100-percent'}/>

                <div className="stm-efc-container" style={{ padding: '0px 20px 10px 20px' }}>
                <div style={{ display: 'flex' , flexDirection: 'row', justifyContent: 'space-around', backgroundColor: 'black', borderRadius: '12px', padding: '12px'}}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '50%', color: 'white'}}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', fontFamily: activeTemplate.templateSetting.text.fontFamily}}>Brilliant by Langham</div>
                            <div style={{ fontSize: '14px' ,fontFamily: activeTemplate.templateSetting.text.fontFamily}}>Join our loyalty program and enjoy exclusive benefits</div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <div
                              style={{ backgroundColor: '#FEFEFE', borderRadius: '24px', padding: '10px 10px 10px 12px', fontSize: '12px', fontWeight: 'bold', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                              onClick={() => window.open('https://www.brilliantbylangham.com/en/enrolment', '_blank')}
                            >
                                <span style={{ fontSize: '14px', display: 'inline-flex', alignItems: 'center', fontFamily: activeTemplate.templateSetting.text.fontFamily }}>Join Now</span>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, marginLeft: '2px' }}>
                                  <path d="M9 6L15 12L9 18" stroke="#715A30" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ padding:  '0 20px 70px 20px', backgroundColor: '#FAFAFA'}}  >
                    <div
                        className='stm-font-weight-bold'
                        style={{
                            fontFamily: activeTemplate?.templateSetting.label.fontFamily,
                            fontSize: `18px`
                        }}
                    >
                        Connect With Us
                    </div>
                    <div style={{ display: 'flex', gap: '16px' }}>
                        <img src={feacbookIcon} alt="Facebook" style={{ width: '36px', height: '36px', cursor: 'pointer' }} onClick={() => window.open('https://www.facebook.com/chelseahotelTO', '_blank')} />
                        <img src={instagramIcon} alt="Instagram" style={{ width: '36px', height: '36px', cursor: 'pointer' }} onClick={() => window.open('https://www.instagram.com/chelseahoteltoronto/?hl=en', '_blank')} />
                        <img src={LinkedIn} alt="LinkedIn" style={{ width: '36px', height: '36px', cursor: 'pointer' }} onClick={() => window.open('https://www.linkedin.com/company/chelsea-hotel-toronto/?viewAsMember=true', '_blank')} />
                    </div>
                </div>
            </Layout>
        )
    }
}

export default (HomeThemeOne)
